import React from 'react'
import { withApollo } from 'react-apollo';
import * as Yup from 'yup'
import { Field, Formik, Form } from 'formik'
import { get } from 'lodash'
import styled from 'styled-components'
import { Text, Row, Column, FormikInput, Button, FlexContainer } from '../src/components/common'
import withAWSAuth from '../src/hoc/withAWSAuth'
import AuthWrapper, { RequestErrorWrapper } from '../src/components/layouts/Auth/Auth.wrapper'
import ConfirmUsernamePage from '../src/components/sections/Auth/update-password'
import Link from '../src/components/routes/Link';
import { generateTraceabilityUtil, updateLastConnection } from '../src/utils/misc';
import logger from '../src/utils/logger';
import { publicRuntimeConfig } from '../src/config';
import { sendAdfsLogin } from '../src/utils/adfsLogin';

const ValidationSchema = Yup.object().shape({
    password: Yup.string()
        .min(8, 'form.validations.min_length')
        .max(20, 'form.validations.max_length')
        .required('form.validations.password_required'),
    username: Yup.string()
        .email('form.validations.email')
        .required('form.validations.required')
})

const FormContainer = styled(FlexContainer)``

const LoginDisplayForm = ({ errors, dirty, isSubmitting, handleSubmit, handleChange, handleReset, submitCount, isValid, ...props }) => (
    <Form onSubmit={handleSubmit} onReset={handleReset}>
        <FormContainer direction='column'>
            <Row>
                <Column justify='flex-end'>
                    <Text text='Iniciar sesión' style={{ fontSize: '1.25rem', color: '#333333' }} />
                </Column>
            </Row>
            <Row>
                <Column>
                    <Field
                        style={{ padding: 0 }}
                        component={FormikInput}
                        name='username'
                        type='input'
                        label='Usuario'
                        hasFeedback
                        disabled={isSubmitting}
                        allowClear
                        submitCount={submitCount}
                    />
                </Column>
            </Row>

            <Row>
                <Column>
                    <Field
                        style={{ padding: 0 }}
                        component={FormikInput}
                        name='password'
                        type='password'
                        label='Clave'
                        hasFeedback
                        allowClear
                        disabled={isSubmitting}
                        submitCount={submitCount}
                    />
                </Column>
            </Row>
            {errors && errors['response'] && <Row>
                <Column>
                    <RequestErrorWrapper>
                        <Text color='#db5959' text={errors['response']} />
                    </RequestErrorWrapper>
                </Column>
            </Row>}
            <Row style={{ margin: '15px 0px' }}>
                <Column>
                    <Button
                        type='submit'
                        className='login-form-butto sisa-buttom'
                        disabled={isSubmitting}
                        loading={isSubmitting}
                    >
                        Iniciar sesión
                    </Button>
                </Column>
            </Row>
            <Row>
                <Column justify='center' style={{ }}>
                    <Link style={{ textAlign: 'center' }} href='/forgot-password'>Recuperar clave</Link>
                </Column>
                {/* <Column justify='center'>
            <a style={{ textAlign: 'center' }} href='/forgot-password'>Ayuda</a>
          </Column> */}
            </Row>
        </FormContainer >
    </Form>
)

const LoginForm = ({ handleSubmit, handleReset, initialValues, isSubmitting }) => (
    <Formik
        onSubmit={handleSubmit}
        onReset={handleReset}
        initialValues={initialValues}
        validationSchema={ValidationSchema}
        render={LoginDisplayForm}
    />
)

class Login extends React.Component {
    state = {
        firstLogin: false,
        credentials: {}
    }

    componentWillMount() {
        if(this.props.session && this.props.session.email){
            this.props.history.push('/orders-monitor');
            return;
        }
        if (publicRuntimeConfig.settings.isProd) {
            sendAdfsLogin();
        }
    }

    handleSubmit = (values, { setSubmitting, setFieldError }) => {
        const { awsAuth } = this.props

        setSubmitting(true)

        awsAuth.login(values)
            .then(async (response) => {
                if (get(response, 'status', {}) === 'NEW_PASSWORD_REQUIRED') {
                    return this.setState({ credentials: values, firstLogin: true })
                }
                const { client } = this.props;
                newrelic.addPageAction('login-button', { user: 'ToBeDefined :-)' });
                logger.info('Probando newrelic');
                await generateTraceabilityUtil(client, { actionId: 5 });
                await updateLastConnection(client);
                window.location.href = '/orders-monitor';
            })
            .catch(async (err) => {
                const errorCode = get(err, 'code');
                console.log(err);
                setFieldError('response', `form.auth.error.${errorCode}`);
                setSubmitting(false);
            })
    }

    render () {
        const { credentials, firstLogin } = this.state
        if (firstLogin) {
            return <ConfirmUsernamePage credentials={credentials} />
        }
        // En prod el acceso es solo por ADFS: no mostramos el formulario mientras el browser navega
        if (publicRuntimeConfig.settings.isProd) {
            return null;
        }
        return (
            <AuthWrapper>
                <LoginForm
                    handleSubmit={this.handleSubmit.bind(this)}
                    initialValues={{ username: '', password: '' }}
                />
            </AuthWrapper>
        )
    }
}
export default withApollo(withAWSAuth(Login));
